import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutoPlanService } from './auto-plan.service';
import { AutoPlanModel } from './models/auto-plan.model';

@Component({
    selector: 'sc-auto-plan',
    templateUrl: './auto-plan.component.html',
    styleUrls: ['./auto-plan.component.scss']
})

export class AutoPlanComponent implements OnInit {
    public planesForm: FormGroup;
    public documentTypes: Array<any>;
    public errorMessages: any;
    public loadingPlans = false;
    public planesOperations: Array<AutoPlanModel>;

    constructor(private _planesService: AutoPlanService) {
        this.documentTypes = [
            {
                key: '96',
                value: 'DNI'
            },
            {
                key: '80',
                value: 'CUIT'
            }
        ];
        this.planesForm = new FormGroup({
            documentType: new FormControl(this.documentTypes[0]),
            documentNumber: new FormControl('', [Validators.required])
        });

        this.errorMessages = {
            required: 'Campo requerido'
        };
    }

    ngOnInit() {
    }

    get isValidForm() {
        return this.planesForm.valid;
    }

    get placeHolder() {
        const placeHolderByDocumentType = {
            '80': 'N° Ej: 20244080977',
            '96': 'N° Ej: 34134123'
        }

        return placeHolderByDocumentType[this.planesForm.value.documentType.key];
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsDirty({ onlySelf: true });
                control.markAsPristine({ onlySelf: true });
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    onSearchPlans() {
        if (!this.planesForm.valid) {
            this.validateAllFormFields(this.planesForm);
        } else {
            this.loadingPlans = true;
            this._planesService.getPlanesByDocument(this.planesForm.value.documentType.key, this.planesForm.value.documentNumber).subscribe(
                (response : any) => {
                    this.loadingPlans = false;
                    this.planesOperations = response.items;
                },
                error => {
                    this.loadingPlans = false;
                }
            );
        }
    }
}
